import React from 'react';
import './Logo.css';

import { images } from '../../constants';

import { Link } from "react-router-dom";



const Logo = () => {

  return (
    // Link to the home page when the logo is clicked
    <Link to='/' className='logo'>

      {/* Logo Image */}
      <img src={images.logo} alt='logo' />

      <div className='logo-name'>
        <h3>TechNova</h3>
      </div>

    </Link>
  );

}

export default Logo;